/** @format */

declare global {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface Window {
        StyleMedia: any;
    }
}

/**
 * Returns whether or not a particular CSS property is supported
 *
 * @param {string} property
 */

function supportsCSSProperty(property: string) {
    return typeof document !== 'undefined' && property in document.body.style;
}

/**
 * Checks if the browser is IE
 */

export function isIE() {
    return supportsCSSProperty('msFlex');
}
/**
 * Checks if the browser is Edge
 * @see https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 */

export function isEdge() {
    return !isIE() && typeof window !== 'undefined' && !!window.StyleMedia;
}
/**
 * Checks if the browser is Safari
 * @see https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 */

export function isSafari() {
    return (
        //@ts-ignore
        /constructor/i.test(window.HTMLElement) ||
        (function (p) {
            return p.toString() === '[object SafariRemoteNotification]';
        })(
            // @ts-ignore - Element implicitly has an any type - Touch and Change
            // eslint-disable-next-line @typescript-eslint/dot-notation
            !window['safari'] ||
                //@ts-ignore
                (typeof safari !== 'undefined' && safari.pushNotification)
        )
    );
}
